export enum UserActionTypeEnum {
	PageViewed = "page_view",
	BetPlaced = "BetPlaced",
	BetSlipViewed = "BetSlipViewed",
	BetConfirmed = "BetConfirmed",
	CashOutRequested = "CashOutRequested",
	DepositInitiated = "DepositInitiated",
	DepositCompleted = "DepositCompleted",
	FirstDeposit = "FirstDeposit",
	WithdrawalInitiated = "WithdrawalInitiated",
	WithdrawalCompleted = "WithdrawalCompleted",
	LoginSuccess = "LoginSuccess",
	FirstLogin = "FirstLogin",
	Logout = "Logout",
	BetSlipInteraction = "BetSlipInteraction",
	BetSlipCancelInteraction = "BetSlipCancelInteraction",
	BetSlipSharePopupAdd = "BetSlipSharePopupAdd",
	RegistrationStarted = "RegistrationStarted",
	RegistrationProcess = "RegistrationProcess",
	RegistrationCompleted = "RegistrationCompleted",
	RegistrationFormCompleted = "RegistrationFormCompleted",
	RegistrationCampaignSubmit = "RegistrationCampaignSubmit",
	RegistrationInteraction = "RegistrationInteraction",
}

export enum EngagementTrackingEnum {
	PromotionBanner = "PromotionBannerClicked",
	NewsLetterSubscribed = "NewsletterSubscribed",
	LiveStreamingViewed = "LiveStreamingViewed",
	SocialMediaShared = "SocialMediaShared",
	EventFavorited = "EventFavorited",
	TournamentFavorited = "TournamentFavorited",
	BettingTypeFavorited = "BettingTypeFavorited",
	SportInteraction = "SportInteraction",
	QuickActionInteraction = "QuickActionInteraction",
	MarketingInteraction = "MarketingInteraction",
	AdditionalOfferInteraction = "AdditionalOfferInteraction",
	LiveSideNavigationInteraction = "LiveSideNavigationInteraction",
	HomepageOfferTabInteraction = "HomepageOfferTabInteraction",
	ChatOpenInteraction = "ChatOpenInteraction",
	QuickPlayInteraction = "QuickPlayInteraction",
	BetBuilderInteraction = "BetBuilderInteraction",
	BetSpotlightInteraction = "BetSpotlightInteraction",
	SportStatisticsInteraction = "SportStatisticsInteraction",
	BetBuilderModalSwitcherInteraction = "BetBuilderModalSwitcherInteraction",
	MostPlayedModalSwitcherInteraction = "MostPlayedModalSwitcherInteraction",
	BetBuilderModalOpen = "BetBuilderModalOpen",
	MostPlayedModalOpen = "MostPlayedModalOpen",
	TournamentSwitcherInteraction = "TournamentSwitcherInteraction",
	EventSwitcherInteraction = "EventSwitcherInteraction",
	LiveEventSwitcherInteraction = "LiveEventSwitcherInteraction",
}

export enum EventTrackingEnum {
	MatchViewed = "MatchViewed",
	CasinoInteraction = "CasinoInteraction",
	UseBetBuilderPick = "UseBetBuilderPick",
	UseMostPlayedTicket = "UseMostPlayedTicket",
}

export enum SearchTrackingEnum {
	SearchButtonClicked = "SearchButtonClicked",
	FreeSearchTrack = "FreeSearchTrack",
	TournamentSearchTrack = "TournamentSearchTrack",
	EventSearchTrack = "EventSearchTrack",
	SearchTermTrack = "SearchTermTrack",
}

export enum UserTypeEnum {
	Online = "online",
	Retail = "retail",
}

export enum LiveEventTypeTrackingEnum {
	LiveAdditionalOfferOpened = "LiveAdditionalOfferOpened",
	LiveEventPageOpened = "LiveEventPageOpened",
	LiveMultiEventAdded = "LiveMultiEventAdded",
}
